import { AbstractDevicePricingItem } from "./abstract-device-pricing-item";

export class DevicePricingItem extends AbstractDevicePricingItem {
    public collectorExtraPrice?: string;
    public oldCollectorExtraPrice?: string;
}
